module.exports = __webpack_public_path__ + "img/pagamento_sucesso.bbf01397.svg";